import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import React from "react";
import { error } from "../../../../theme/themePrimitives";

interface DeleteGroupModalProps {
  openDeleteGroupModal: boolean;
  setOpenDeleteGroupModal: React.Dispatch<React.SetStateAction<boolean>>;
  modalTitle: string;
  modalSubtitle: string;
  confirmButtonClick: () => void;
  handleModalConfirm?: () => void;
  modalLoading?: boolean;
}

export const DeleteGroupModal: React.FC<DeleteGroupModalProps> = ({
  openDeleteGroupModal,
  setOpenDeleteGroupModal,
  modalSubtitle,
  modalTitle,
  confirmButtonClick,
  handleModalConfirm,
  modalLoading,
}) => {
  return (
    <Modal
      open={openDeleteGroupModal}
      onClose={() => setOpenDeleteGroupModal(false)}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          maxHeight: "90vh",
          overflowY: "auto",
          backgroundColor: "white",
          borderRadius: "8px",
          boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.24)",
          width: "50%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "16px",
            pb: 0,
          }}
        >
          <Typography variant="h5">{modalTitle}</Typography>

          <IconButton
            sx={{
              border: "none",
            }}
            onClick={() => setOpenDeleteGroupModal(false)}
          >
            <CloseIcon sx={{ color: "#98A2B3" }} />
          </IconButton>
        </Box>
        <Box sx={{ padding: "16px", pt: 0 }}>
          <Typography variant="body2" color="textSecondary">
            {modalSubtitle}
          </Typography>
        </Box>
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", padding: "16px" }}
        >
          <Box sx={{ display: "flex", gap: "1rem" }}>
            <Button
              onClick={() => setOpenDeleteGroupModal(false)}
              sx={{
                px: 2,
                border: "1px solid #D0D5DD",
                borderRadius: "8px",
                backgroundColor: `white !important`,
                color: "black",
              }}
            >
              <Typography>No, I don't Want</Typography>
            </Button>
            {modalLoading ? (
              <CircularProgress />
            ) : (
              <Button
                onClick={async () => {
                  if (handleModalConfirm) {
                    await handleModalConfirm();
                  }
                  confirmButtonClick();
                }}
                sx={{
                  px: 2,
                  borderRadius: "8px",
                  backgroundColor: `${error[600]} !important`,
                  color: "white",
                }}
              >
                <Typography>Yes, I'm sure</Typography>
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
